var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEducationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "#384A5F",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.455 6.55l12 5.255 12-5.255-12-5.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.457 7.865v2.764c0 2.523 4.133 5.058 9.231 5.058s9.231-2.535 9.231-5.058V7.661"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14.688 6.1L8.105 9.024v8.074"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.40298cafc08b4bbde7d51462e7fa7828.svg";
export { ForwardRef as ReactComponent };